import {
    FreemiumBanner,
    InstallPwaPopup,
    LandingEighthScreen,
    LandingFifthScreen,
    LandingFirstScreen,
    LandingFooter,
    LandingFourthScreen,
    LandingHeader,
    LandingSecondScreen,
    LandingSeventhScreen,
    LandingSixthScreen,
    LandingThirdScreen,
} from "components/landingNew";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { checkIsMobile, checkPwa } from "helpers/devices";
import Cookies from "js-cookie";
import { useHistory } from "react-router-dom";
import { selectUser } from "redux/authReducer";
import axios from "axios";

/**
 * @api {get} / лендинг
 * @apiGroup main
 * @apiName лендинг
 * @apiDescription <p>Главная страница / лендинг</p>
 * <p>Компонент <code>LandingPageNew.jsx</code> <a href="../client/src/pages/LandingPageNew.jsx">ссылка на файл</a></p>
 */

const isPwa = checkPwa();

export const LandingPageNew = () => {
    const { user, role } = useSelector(selectUser);
    const dispatch = useDispatch();
    const history = useHistory();
    const [showBanner, setShowBanner] = useState(false);
    const [isShowInstallPwaPopup, setIsShowInstallPwaPopup] = useState(false);
    const [isParentOnClick, setIsParentOnClick] = useState(false);

    useEffect(() => {
        if (!user) {
            (async () => {
                try {
                    const { data } = await axios.get("auth/user");
                    dispatch({ type: "AUTH/SET_USER", payload: data });
                } catch (e) {}
            })();
        }
    }, [dispatch, user]);

    useEffect(() => {
        if (isPwa && localStorage.getItem("pwaUser")) {
            history.push("/pincode");
        } else if (!Cookies.get("hidePwaInstallPopup") && checkIsMobile()) {
            setIsShowInstallPwaPopup(true);
        }
    }, [history]);

    const showBannerHandler = useCallback(() => {
        setShowBanner(!showBanner);
    }, [showBanner]);

    const showInstallPwaPopupHandler = useCallback(() => {
        setIsShowInstallPwaPopup(true);
    }, []);

    const hideInstallPwaPopupHandler = useCallback(() => {
        setIsShowInstallPwaPopup(false);
    }, []);

    const expandParentsBlock = useCallback(() => {
        setIsParentOnClick(true);
    }, []);

    return (
        <div className="landing-new">
            <InstallPwaPopup closePopup={hideInstallPwaPopupHandler} isOpen={isShowInstallPwaPopup} />
            <LandingHeader user={user} role={role} showBanner={showBannerHandler} />
            <LandingFirstScreen user={user} expandParentsBlock={expandParentsBlock} />
            <LandingSecondScreen />
            <LandingThirdScreen />
            <LandingFourthScreen />
            <LandingFifthScreen showBanner={showBannerHandler} />
            <LandingSixthScreen />
            <LandingSeventhScreen />
            <LandingEighthScreen isParentOnClick={isParentOnClick} />
            <LandingFooter showInstallPwaPopupHandler={showInstallPwaPopupHandler} />
            <FreemiumBanner showBanner={showBanner} closePopup={showBannerHandler} />
        </div>
    );
};
